import axios from '../localAxios';
import { Workspace } from './types';
import { workspacesURL } from './workspacesURLs';

export async function getUserWorkspaceList() {
  const { data } = await axios.get<Workspace[]>(workspacesURL().href);
  return data;
}
